<a [href]="shortcut.url" [target]="shortcut.is_external ? '_blank' : '_self'">
  <div>{{ shortcut.name }}</div>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33337 8H12.6667" stroke="#ED3C6A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M8 3.33325L12.6667 7.99992L8 12.6666"
      stroke="#ED3C6A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</a>
